import React from 'react';
import Sheet from 'react-modal-sheet';
import { PiXCircle } from 'react-icons/pi';
import { Box, IconButton, CircularProgress } from '@material-ui/core';
import Player from './Player';
import { useTheme } from '../contexts/theme';
import { useExperience } from '../contexts/experience';
import { useLanguage } from '../contexts/language';
import { useFocusRestore } from '../hooks/useFocusRestore';

const PlayerBottomSheet = ({ openSheet, setOpenSheet, triggerRef }) => {
  const { isActive } = useExperience();
  const { styles } = useTheme();
  const { content } = useLanguage();
  const closeButtonRef = React.useRef(null);
  const backgroundColor = styles.palette.background.default;
  useFocusRestore({
    isOpen: openSheet,
    focusRef: closeButtonRef,
    returnFocusRef: isActive ? triggerRef : null,
  });

  const handleClose = () => setOpenSheet(false);

  return (
    <Sheet isOpen={openSheet} onClose={handleClose}>
      <Sheet.Container
        style={{ backgroundColor }}
        data-testid="agami-audio-player-bottom-sheet-container"
        role="dialog"
        aria-modal="true"
        aria-label={content('aria_audio_player_dialog')}
        tabIndex={-1}
      >
        <Sheet.Header />
        <Sheet.Content>
          <Box position="absolute" top="-30px" right={0}>
            <IconButton
              ref={closeButtonRef}
              onClick={handleClose}
              aria-label={content('aria_close_audio_player')}
            >
              <PiXCircle aria-hidden />
            </IconButton>
          </Box>

          {!isActive && (
            <Box
              position="absolute"
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="100%"
              height="100%"
              aria-busy="true"
              aria-live="polite"
            >
              <CircularProgress color="secondary" size={55} />
            </Box>
          )}

          <Player />
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop />
    </Sheet>
  );
};

export default PlayerBottomSheet;
